import useGetAgent from '@/hooks/useGetAgent';
import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Dialog, DialogContent } from './ui/dialog';

interface Props {
  isOpen: boolean;
  setIsOpen: () => void;
}

const NoSoldPriceModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  const [query] = useSearchParams();

  const agentIdentifier = useMemo(() => {
    const agent = query.get('agent');
    if (agent) window.localStorage.setItem('agent', agent.replace(' ', '+'));
    const localAgent = window.localStorage.getItem('agent');
    return localAgent;
  }, [query]);

  const { data: agent } = useGetAgent(agentIdentifier);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md px-4">
        <h2 className="text-2xl font-semibold text-center">
          This property may be keeping a secret 🤫
        </h2>
        {agent ? (
          <p>
            Because you are located in a non-disclosure state, the final sales
            price of comparable properties isn’t publicly reported. This may be
            another reason the county assessor gets your value wrong. To finish
            the analysis, please reach out to {agent?.firstName} at{' '}
            {agent?.phoneNumber} or {agent?.emailAddress} for help confirming
            the sold prices of comparable sales. As a Realtor they have access
            to this information.
          </p>
        ) : (
          <p>
            Because you are located in a non-disclosure state, the final sales
            price of comparable properties may not be publicly available. This
            is potentially a reason why the county assessor may have your value
            wrong! To finish the analysis if sold comparables don't have a sale
            price, invite your favorite real estate agent to create a free
            account at{' '}
            <a className="text-blue-600" href="https://propertytaxhero.com/">
              PropertyTaxHero.com
            </a>{' '}
            and complete the analysis using the confidential sold prices that
            they have access to. We can help you find an agent.
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NoSoldPriceModal;
